const he = {
  pleaseEnterUsername: "נא להזין שם משתמש",
  cannotFriendYourself: "לא ניתן לשלוח בקשת חברות לעצמך.",
  friendRequestSent: "בקשת החברות נשלחה!",
  failedToSendRequest: "שליחת הבקשה נכשלה",
  linkCopied: "הקישור הועתק ללוח!",
  backToInvites: "חזרה להזמנות",
  sendFriendRequestByUsername: "שליחת בקשת חברות לפי שם משתמש",
  enterUsername: "הזן שם משתמש",
  send: "שלח",
  yourInviteQrCode: "קוד ה-QR שלך להזמנה",
  inviteLink: "קישור הזמנה",
  scanQrOrUseLink: "סרוק את קוד ה-QR הזה או השתמש בקישור זה כדי לשלוח בקשת חברות",
  copyInviteLink: "העתק קישור הזמנה",
  goToItem: "עבור לפריט",
  verificationEmailSent: "מייל האימות נשלח! בדוק את תיבת הדואר שלך.",
  verificationEmailFailed: "שליחת מייל האימות נכשלה. נסה שוב.",
  verifyYourEmail: "אמת את כתובת הדוא״ל שלך",
  verifyEmailInstructions: "נא לאמת את כתובת הדוא״ל שלך כדי לגשת לחשבון. בדוק את תיבת הדואר שלך לקבלת קישור האימות.",
  sending: "שולח...",
  resendVerificationEmail: "שלח מחדש מייל אימות",
  login: "התחברות",
  register: "הרשמה",
  home: "בית",
  calendar: "לוח שנה",
  friends: "חברים",
  profile: "פרופיל",
  logout: "התנתקות",
  loading: "טוען...",
  language: "שפה",
  calendarSelectPlaceSuggestion: "נא לבחור מקום מתוך ההצעות כדי לצרף את הקואורדינטות.",
  calendarSelectDateAndTime: "נא לבחור תאריך ושעה.",
  calendarPositiveDuration: "נא להזין משך זמן חיובי.",
  calendarFutureDateRequired: "תאריך ושעת האירוע חייבים להיות בעתיד.",
  calendarCreateEventFailed: "יצירת האירוע נכשלה. נסה שוב.",
  cancel: "ביטול",
  createNewEvent: "יצירת אירוע חדש",
  week: "שבוע",
  month: "חודש",
  eventTitle: "כותרת",
  date: "תאריך",
  time: "שעה",
  duration: "משך",
  endsAt: "מסתיים ב־",
  place: "מקום",
  searchForPlace: "חפש מקום",
  placeSearchTip: "טיפ: התחל להקליד ובחר תוצאה כדי לצרף קואורדינטות.",
  description: "תיאור",
  createEvent: "צור אירוע",
  today: "היום",
  previousMonth: "חודש קודם",
  nextMonth: "חודש הבא",
  previous: "הקודם",
  next: "הבא",
  mondayShort: "ב׳",
  tuesdayShort: "ג׳",
  wednesdayShort: "ד׳",
  thursdayShort: "ה׳",
  fridayShort: "ו׳",
  saturdayShort: "ש׳",
  sundayShort: "א׳",
  more: "עוד",
  mustRespondWillBeforeReposting: "עליך לבחור \"אגיע\" לפני פרסום מחדש",
  event: "אירוע",
  backToCalendar: "חזרה ללוח השנה",
  addToGoogleCalendar: "הוסף ל-Google Calendar",
  when: "מתי",
  where: "איפה",
  openLocationInGoogleMaps: "פתח מיקום ב-Google Maps",
  hosts: "מארחים",
  yourResponse: "התגובה שלך",
  currentResponse: "תגובה נוכחית",
  response_will: "אגיע",
  response_might: "אולי אגיע",
  response_wont: "לא אגיע",
  willRunIntoYou: "אקפוץ",
  mightDropBy: "אולי אקפוץ",
  wontCome: "לא אבוא",
  repostToMyFriends: "פרסום מחדש לחברים שלי",
  responses: "תגובות",
  willAttend: "יגיע",
  reposted: "פורסם מחדש",
  mightAttend: "אולי יגיע",
  cancelEvent: "ביטול האירוע",
  cancellationEmailNoticeBefore: "משתתפים שאישרו הגעה",
  cancellationEmailNoticeAfter: "יקבלו הודעת דוא״ל על ביטול האירוע.",
  optionalCancellationMessage: "הודעה אופציונלית למשתתפים (עד 1000 תווים)",
  confirmCancelEvent: "אשר ביטול אירוע",
  clear: "נקה",
  confirmCancellation: "אשר ביטול",
  confirmCancellationMessage: "האם אתה בטוח שברצונך לבטל את האירוע? המשתתפים שאישרו יקבלו הודעה והאירוע יוסר.",
  eventCancelledNotified: "האירוע בוטל. נשלחה הודעה ל־",
  attendees: "משתתפים",
  failedToCancelEvent: "ביטול האירוע נכשל",
  back: "חזרה",
  cancelled: "בוטל",
  ok: "אישור",
  forgotPassword: "שכחתי סיסמה",
  email: "דוא״ל",
  passwordResetLinkSent: "אם החשבון קיים, נשלח קישור לאיפוס סיסמה.",
  passwordResetRequestFailed: "בקשת איפוס הסיסמה נכשלה.",
  sendResetLink: "שלח קישור לאיפוס",
  addFriend: "הוסף חבר",
  incomingRequests: "בקשות נכנסות",
  accept: "אשר",
  deny: "דחה",
  myFriends: "החברים שלי",
  noFriendsYet: "עדיין אין לך חברים. התחל להוסיף!",
  seeProfile: "הצג פרופיל",
  noEventsToRespondTo: "אין אירועים להגיב אליהם",
  allCaughtUp: "אתה מעודכן. חזור מאוחר יותר לאירועים חדשים מחבריך.",
  events: "אירועים",
  unknown: "לא ידוע",
  noDescriptionProvided: "לא סופק תיאור.",
  will: "כן",
  maybe: "אולי",
  wont: "לא",
  userNotFound: "המשתמש לא נמצא",
  friendRequestSentSuccessfully: "בקשת החברות נשלחה בהצלחה!",
  friendInvitation: "הזמנת חברות",
  sendFriendRequest: "שלח בקשת חברות",
  loginToSendFriendRequest: "נא להתחבר כדי לשלוח בקשת חברות",
  chooseLanguage: "בחר שפה",
  invalidCredentials: "פרטי ההתחברות שגויים. נסה שוב.",
  username: "שם משתמש",
  password: "סיסמה",
  forgotPasswordQuestion: "שכחת סיסמה?",
  dontHaveAccount: "אין לך חשבון?",
  registerHere: "הירשם כאן",
  invalidProfilePhotoType: "סוג קובץ לא תקין. העלה תמונת JPEG, PNG, GIF או WebP.",
  invalidFileExtension: "סיומת קובץ לא תקינה",
  allowedExtensions: "מותר",
  fileTooLarge: "הקובץ גדול מדי",
  maximumFileSize: "מקסימום",
  profilePhotoRemoved: "תמונת הפרופיל הוסרה.",
  failedToRemoveProfilePhoto: "הסרת תמונת הפרופיל נכשלה",
  profileUpdatedSuccessfully: "הפרופיל עודכן בהצלחה!",
  failedToUpdateProfile: "עדכון הפרופיל נכשל",
  privateEmailExplanation: "רק אתה יכול לראות את כתובת הדוא״ל שלך כדי למנוע הודעות לא רצויות מחוץ לפלטפורמה",
  yourEmailIsPrivate: "כתובת הדוא״ל שלך פרטית.",
  profilePhoto: "תמונת פרופיל",
  removePhoto: "הסר תמונה",
  firstName: "שם פרטי",
  lastName: "שם משפחה",
  tellPeopleAboutYourself: "ספר לאחרים על עצמך",
  whereToContactMe: "איך ליצור איתי קשר",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "שמור",
  notSet: "לא הוגדר",
  editProfile: "ערוך פרופיל",
  imageToCrop: "תמונה לחיתוך",
  zoom: "זום",
  usePhoto: "השתמש בתמונה",
  name: "שם",
  whereToContact: "פרטי קשר",
  removeFriendship: "הסר חברות",
  confirmRemoveFriend: "אשר הסרת חבר",
  confirmRemoveFriendBefore: "האם אתה בטוח שברצונך להסיר את",
  confirmRemoveFriendAfter: "מרשימת החברים שלך?",
  friendRemoved: "החבר הוסר.",
  failedToRemoveFriend: "הסרת החבר נכשלה.",
  confirmRemove: "אשר הסרה",
  error: "שגיאה",
  removed: "הוסר",
  passwordsDoNotMatch: "הסיסמאות אינן תואמות",
  registrationFailed: "ההרשמה נכשלה. נסה שוב.",
  confirmPassword: "אימות סיסמה",
  alreadyHaveAccount: "יש לך כבר חשבון?",
  loginHere: "התחבר כאן",
  passwordResetSuccessfully: "הסיסמה אופסה בהצלחה.",
  failedToResetPassword: "איפוס הסיסמה נכשל.",
  resetPassword: "איפוס סיסמה",
  newPassword: "סיסמה חדשה",
  confirmNewPassword: "אימות סיסמה חדשה",
  setNewPassword: "הגדר סיסמה חדשה",
  emailVerifiedSuccessfully: "כתובת הדוא״ל אומתה בהצלחה!",
  emailVerificationFailed: "האימות נכשל. ייתכן שהקישור אינו תקין או שפג תוקפו.",
  verifying: "מאמת...",
  verified: "אומת!",
  redirectingToHome: "מעביר לדף הבית...",
  verificationFailed: "האימות נכשל",
  goToHome: "עבור לדף הבית",
  about: "אודות",
  aboutConceptTitle: "רעיון",
  aboutCreatorIntroduction: "שלום, אני Crypt0, מטפס ויוצר Run Into Me.",
  aboutCreatorStory: "יצרתי את האתר כי אני חברותי והשקעתי יותר מדי זמן בתיאום מפגשי טיפוס עם מטפסים אחרים.",
  aboutPlanningProblem: "רציתי לעדכן את כולם בו-זמנית מתי ואיפה אטפס, בלי הזמנה רשמית.",
  aboutDeveloperSolution: "אז נזכרתי שאני מפתח ויכול ליצור את הפתרון בעצמי.",
  aboutWelcome: "ברוכים הבאים ל-Run Into Me, מקום לעדכן חברים על פעילויות שאליהן אפשר להצטרף בלי לחץ.",
  aboutCallToAction: "פרסמו כאן את הפעילות הבאה שכיף יותר לעשות יחד!",
  aboutTutorialTitle: "מדריך",
  aboutCalendarCreateEvent: "במסך לוח השנה אפשר גם ליצור אירוע חדש.",
  aboutEventColorsIntroduction: "הצבעים מציינים את מצב ההשתתפות:",
  aboutColorGold: "זהב",
  aboutColorGoldDescription: "זהו אירוע שאתם מארחים.",
  aboutColorGreen: "ירוק",
  aboutColorGreenDescription: "אתם משתתפים באירוע.",
  aboutColorOrange: "כתום",
  aboutColorOrangeDescription: "עניתם „אולי”.",
  aboutColorBlue: "כחול",
  aboutColorBlueDescription: "עדיין לא עניתם.",
  aboutColorGray: "אפור",
  aboutColorGrayDescription: "דחיתם את ההזמנה.",
  aboutCalendarEventDetails: "לחצו על אירוע לפרטים ולתגובה.",
  aboutFriendPageTitle: "דף חברים",
  aboutFriendPageDescription: "הזינו שם משתמש או שלחו קישור הזמנה / קוד QR.",
  aboutHomePageTitle: "דף הבית",
  aboutHomePageDescription: "עברו על האירועים הקרובים וציינו אם תגיעו.",
  aboutRepostScreenTitle: "מסך פרסום מחדש",
  aboutGoogleCalendarDescription: "הוסיפו את האירוע ליומן Google באמצעות הכפתור.",
  aboutRepostDescription: "לאחר אישור ההגעה אפשר לפרסם את האירוע מחדש לחברים.",
};

export default he;